import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import MyTop from "../containers/my/MyTop";
import MyZzim from "../containers/my/MyZzim";

// import MyLive from "../containers/my/MyLive";
import MyMemberShip from "../containers/my/MyMemberShip";

import MyView from "../containers/my/MyView";
import MyDown from "../containers/my/MyDown";
import MyCash from "../containers/my/MyCash";
import MyLeague from "../containers/my/MyLeague";
import MyReview from "../containers/my/MyReview";
import MyQna from "../containers/my/MyQna";
import Footer from "../components/Footer";
class My extends Component {
  state = {
    tabIndex: 0,
  };

  componentDidMount = () => {
    const { match } = this.props;
    let index = match.params.index;
    ////console.log(match)
    //console.log(index)
    if (index === "" || index === null || index === undefined) {
      index = 0;
    }

    setTimeout(() => {
      this.setState({
        tabIndex: parseInt(index),
      });
    }, 500);
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    // return false 하면 업데이트를 안함
    const { match } = this.props;
    ////console.log(nextProps)
    ////console.log(this.state)
    ////console.log(nextProps.pro)
    return match.params.index !== nextProps.match.params.index;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    //const { match } = this.props;
    ////console.log(nextProps)

    let index = nextProps.match.params.index;
    ////console.log(match)
    //console.log(index)
    if (index === "" || index === null || index === undefined) {
      index = 0;
    }

    setTimeout(() => {
      this.setState({
        tabIndex: parseInt(index),
      });
    }, 500);
  };
  _onTabChange = (tabIndex) => {
    const { history } = this.props;
    history.push("/my/" + tabIndex);
    /*
        this.setState({
            tabIndex
        })
        */
  };

  render() {
    const { tabIndex } = this.state;
    return (
      <Fragment>
        <MyTop tabIndex={tabIndex} onTabChange={this._onTabChange} />
        {tabIndex === 0 ? (
          <MyZzim tabIndex={tabIndex} />
        ) : tabIndex === 1 ? (
          <MyMemberShip />
        ) : /*
                    <MyLive 
                        tabIndex={tabIndex} 
                    />
                    */
        tabIndex === 2 ? (
          <MyView tabIndex={tabIndex} />
        ) : tabIndex === 3 ? (
          <MyDown tabIndex={tabIndex} />
        ) : tabIndex === 4 ? (
          <MyCash tabIndex={tabIndex} />
        ) : tabIndex === 5 ? (
          <MyLeague tabIndex={tabIndex} />
        ) : tabIndex === 6 ? (
          <MyReview tabIndex={tabIndex} />
        ) : tabIndex === 7 ? (
          <MyQna tabIndex={tabIndex} />
        ) : null}

        {/*
                <div className="mypage_content">
                    <div className="mypage_group">
                        <h1>내가 찜한 작품<span>(25)</span><div><a href="#">전체 삭제<img src="/img/mypage/del.png"/></a></div></h1>
                        <div className="main_list_goup1">
                            <div className="div_ul">
                                <div className="div_li">
                                    <div className="list_img_bg"><img src="/img/test_img8.png"/></div>
                                    <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                                </div>
                                
                                <div className="div_li">
                                    <div className="list_img_bg"><img src="/img/test_img8.png"/></div>
                                    <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                                </div>
                            </div>
                            <div className="clear"></div>
                        </div>
                        <div className="vod_loading"><img src="/img/vod/vod_loading.png"/></div>
                    </div>
                
                </div>
                */}
        <Footer />
      </Fragment>
    );
  }
}

export default shopContext(withRouter(My));
